/* eslint-disable no-undef */

const getInfoDesignPm = (uuid) => `/property-managers/${uuid}/info/`;

const getInfoDesignSubmain = (subdomain) =>
  `/property-managers/info/?subdomain=${subdomain}`;

const sendOTPCode = `/landlords/subscriptions/otp/send/`;
const sendOTPCodeV2 = `/owner-dashboard/subscriptions/otp/send/`;

const urls = {
  getInfoDesignPm,
  sendOTPCode,
  getInfoDesignSubmain,
  sendOTPCodeV2
};

export { urls };
